module.exports = __webpack_public_path__ + "static/media/optional.4827bcf1.png";